import { Link, useLocation } from "react-router-dom";

const ROUTES = [
  { path: "/", label: "./home", number: "00" },
  { path: "/work", label: "./work", number: "01" },
  { path: "/gallery", label: "./gallery", number: "02" },
  { path: "/contact", label: "./contact", number: "03" },
];

export default function ChapterNav() {
  const location = useLocation();
  const currentIndex = ROUTES.findIndex((r) => r.path === location.pathname);

  const prev = currentIndex > 0 ? ROUTES[currentIndex - 1] : null;
  const next = currentIndex < ROUTES.length - 1 ? ROUTES[currentIndex + 1] : null;

  if (currentIndex === -1) return null;

  return (
    <>
      {prev && (
        <Link to={prev.path} className="chapter-nav chapter-nav--prev">
          <span className="arrow arrow--left">←</span>
          <span>{prev.label}</span>
          <span className="number">{prev.number}</span>
        </Link>
      )}
      {next && (
        <Link to={next.path} className="chapter-nav chapter-nav--next">
          <span className="number">{next.number}</span>
          <span>{next.label}</span>
          <span className="arrow arrow--right">→</span>
        </Link>
      )}
    </>
  );
}
